import React, { useState, useEffect, useContext } from "react";
import {
	List,
	Space,
	Skeleton,
	Button,
	Drawer,
	message,
	Input,
	Checkbox,
	Transfer,
	Tooltip,
	Modal,
	Select,
	Row,
	Col,
	Divider,
	Table,
	Badge,
	InputNumber,
	theme
} from "antd";
import { ReloadOutlined, LoadingOutlined, SearchOutlined, EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { reload_nomenclature, edit_company, get_company_by_nit_for_entity } from "../services";
import { useCalculateListSizeForPaginationHook } from "../hooks";
import { reduceText } from "../utils/Formaters";

import PropTypes from "prop-types";
import { Contacts } from "../components/entities/components/Contacts";
import { InformationComponent } from "../components/InformationComponent";
import { TypeTidCategory, UserRols } from "../constants";
import { isObjectEmpty } from "../utils/ObjectOperators";
import { hover_item } from "../hover";
import { CompaniesContext } from "../contexts";

const no_selected_company = {
	id: "",
	address: "",
	country: "",
	description: "",
	is_associated_company: true,
	name: "",
	plan: "",
	accounting_resources: {
		accounting_plan: [],
		diaries: [],
		expense_accounts: [],
		sale_accounts: [],
		others:{
			analytic_accounts:[]
		}
	},
	database_id: "",
	tax_authority_specifications: {
		agente_retenedor_iva: false,
		establishments: [],
		isr_regimen: "",
		iva_regimen: ""
	},
	email_emition_specifications: {
		email: "",
		password: "",
		host: ""
	},
	looker_link: "",
	database: null,
	type_tid: "",
};

const { TextArea } = Input;

const no_new_company =  {
	name: "",
	tid: "",
	type_tid: "",
};

const no_new_establishment = {
	id: 0,
	name: "",
	state: true
};

const optionsTidTypes = [
	{
		value: "company",
		label: "NIT",
	},
	{
		value: "person",
		label: "CUI",
	}
];

export const Companies = ({ token, user }) => {
	const {token: antToken} = theme.useToken();
	
	const { companies, updateCompaniesIncludingLocalStorage } = useContext(CompaniesContext);
	
	const [loading, setLoading] = useState(true);
	const [loadingCreateCompany, setLoadingCreateCompany] = useState(false);
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const [nomenclatureLoading, setNomenclatureLoading] = useState(false);

	const [open, setOpen] = useState(false);
	const [openCreateEsablishment, setOpenCreateEstablishment] = useState(false);
	const [openEditEsablishment, setOpenEditEstablishment] = useState(false);
	const placement = "right";
	const { pageSize } = useCalculateListSizeForPaginationHook(40);

	const [companiesTable, setCompaniesTable] = useState([]);
	const [selected, setSelected] = useState(no_selected_company);
	const [selectedKeysExpenses, setSelectedKeysExpenses] = useState([]);
	const [selectedKeysSales, setSelectedKeysSales] = useState([]);

	const [establishment, setEstablishment] = useState(no_new_establishment);

	const [openCreate, setOpenCreate] = useState(false);
	const [openConsultCompany, setOpenConsultCompany] = useState(false);

	const [hoveredItem, setHoveredItem] = useState(null);

	const [newCompany, setNewCompany] = useState(no_new_company);

	const stablishment_columns = [
		{
			title: "Nombre",
			dataIndex: "name",
			showSorterTooltip: {
				target: "full-header",
			},
			width: 300,
			sorter: (a, b) => a.name.length - b.name.length,
			sortDirections: ["descend"],
		},
		{
			title: "Código",
			dataIndex: "id",
			defaultSortOrder: "descend",
			width: 150,
			sorter: (a, b) => a.age - b.age,
		},
		{
			title: "Estado",
			dataIndex: "state",
			width: 150,
			filters: [
				{
					text: "Activo",
					value: true,
				},
				{
					text: "Inactivo",
					value: false,
				},
			],
			onFilter: (value, record) => record.state === value,
			render: (value) => <Badge status={value? "success" : "default"} text={value? "Activo" : "Inactivo"} />,
		},
		{
			title: "Edición",
			key: "edit",
			render: (value) => <a onClick={() => showEditEstablishment(value)}>Editar</a>
		},
		{
			title: "Activación",
			key: "activate",
			render: (value) => ( value.state? 
				<a onClick={() => {handleToggleActivationEstablishment(value);}}>Desactivar</a> : 
				<a onClick={() => {handleToggleActivationEstablishment(value);}}>Activar</a>
			)
		}
	];
	

	/* CREATE COMPANY */

	const showCreateCompanyModal = () => {
		setOpenCreate(true);
	};

	const cancelCreateCompany = () => {
		setOpenCreate(false);
	};

	/* COMPONENT VARIABLES */

	const showEdit = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
		setSelected(no_selected_company);
	};
	const showCreateEstablishment = () => {
		setOpenCreateEstablishment(true);
	};
	const onCloseCreateEstablishment = () => {
		setOpenCreateEstablishment(false);
	};
	const showEditEstablishment = (value) => {
		setEstablishment(value);
		setOpenEditEstablishment(true);
	};
	const onCloseEditEstablishment = () => {
		setEstablishment(no_new_establishment);
		setOpenEditEstablishment(false);
	};

	/* SELECT INVOICE */

	const handleChangeNomenclatureExpenses = (newTargetKeys) => {
		const newSelected = {
			...selected,
			accounting_resources: {
				...selected.accounting_resources,
				expense_accounts: newTargetKeys
			}
		};
		setSelected(newSelected);
	};
	const handleChangeNomenclatureSales = (newTargetKeys) => {
		const newSelected = {
			...selected,
			accounting_resources: {
				...selected.accounting_resources,
				sale_accounts: newTargetKeys
			}
		};
		setSelected(newSelected);
	};

	const handleSelectChangeNomenclatureExpenses = (
		sourceSelectedKeys,
		targetSelectedKeys
	) => {
		setSelectedKeysExpenses([...sourceSelectedKeys, ...targetSelectedKeys]);
	};
	const handleSelectChangeNomenclatureSales = (
		sourceSelectedKeys,
		targetSelectedKeys
	) => {
		setSelectedKeysSales([...sourceSelectedKeys, ...targetSelectedKeys]);
	};

	const handleReloadNomenclature = async () => {
		setNomenclatureLoading(true);

		try {
			const resReload = await reload_nomenclature(token, selected.id);

			if (resReload) {
				message.success(
					"Recarga de nomenclatura en proceso, los cambios pueden tardar hasta 1 minuto."
				);
			}
		} catch (error) {
			message.error("Ha ocurrido un error");
		} finally {
			setNomenclatureLoading(false);
		}
	};

	/* SEARCH COMPANY */

	useEffect(() => {
		setCompaniesTable(companies);
		setLoading(false);
	}, []);

	const onChangeSearch = (value) => {
		const text = value.target.value;

		const matchesText = (str) => {
			if (typeof str === "string") {
				return str.toLowerCase().includes(text.toLowerCase());
			}
			else if (typeof str === "number") {
				return String(str).toLowerCase().includes(text.toLowerCase());
			}
			return false;
		};

		const checkObjectForMatch = (obj) => {
			for (const key in obj) {
				if (matchesText(obj[key])) {
					return true;
				}

				if (typeof obj[key] === "object" && obj[key] !== null) {
					if (checkObjectForMatch(obj[key])) {
						return true;
					}
				}
			}
			return false;
		};

		if (text === "") {
			setCompaniesTable(companies);
		} else {
			const resultado = companies.filter((company) =>
				checkObjectForMatch(company)
			);
			setCompaniesTable(resultado);
		}
	};

	/* EDITING COMPANY PROPERTIES */

	const updateSelected = (path, value) => {
		const newSelected = { ...selected };

		const keys = path.split(".");
		let current = newSelected;

		for (let i = 0; i < keys.length - 1; i++) {
			current = current[keys[i]] = { ...current[keys[i]] };
		}

		current[keys[keys.length - 1]] = value;
		setSelected(newSelected);
	};

	const handleCreateEstablishment = () => {
		// Asegurarnos de que 'establishments' exista como un array
		const establishments = selected.tax_authority_specifications.establishments || [];

		// Verificar si ya existe un establecimiento con el mismo id
		const found_establishment = establishments.find(company_establishment => company_establishment.id === establishment.id);

		if (found_establishment) {
			message.error("Un establecimiento con ese código ya existe");
		} else if (establishment.id < 1) {
			message.error("Código incorrecto");
		} else {
			// Crear una copia de 'selected' y su array 'establishments'
			const new_selected = {
				...selected,
				tax_authority_specifications: {
					...selected.tax_authority_specifications,
					establishments: [...establishments, establishment] // Añadir el nuevo establecimiento al array
				}
			};
		
			// Actualizar el estado con la nueva referencia
			setSelected(new_selected);
			setEstablishment(no_new_establishment);
			onCloseCreateEstablishment();
			message.info("Para guardar los cambios selecciona \"Modificar\"");
		}
	};
  

	const handleEditEstablishment = () => {
		// Crear una copia de 'establishments' con el establecimiento modificado
		const new_establishments = selected.tax_authority_specifications.establishments.map(company_establishment =>
			company_establishment.id === establishment.id 
				? { ...company_establishment, name: establishment.name } // Modificar el nombre del establecimiento
				: company_establishment
		);

		// Crear una nueva copia de 'selected' con el array de 'establishments' actualizado
		const new_selected = {
			...selected,
			tax_authority_specifications: {
				...selected.tax_authority_specifications,
				establishments: new_establishments
			}
		};

		// Actualizar el estado con el nuevo 'selected'
		setSelected(new_selected);

		// Resetear el formulario o los valores del establecimiento si es necesario
		setEstablishment(no_new_establishment);

		// Cerrar el diálogo o la ventana de edición
		onCloseEditEstablishment();

		// Mostrar el mensaje de información
		message.info("Para guardar los cambios selecciona \"Modificar\"");
	};

	const handleToggleActivationEstablishment = (establishment) => {
		// Crear una copia de 'establishments' con el estado del establecimiento invertido
		const new_establishments = selected.tax_authority_specifications.establishments.map(company_establishment =>
			company_establishment.id === establishment.id
				? { ...company_establishment, state: !company_establishment.state } // Invertir el estado
				: company_establishment
		);
	
		// Crear una nueva copia de 'selected' con el array de 'establishments' actualizado
		const new_selected = {
			...selected,
			tax_authority_specifications: {
				...selected.tax_authority_specifications,
				establishments: new_establishments
			}
		};

		// Actualizar el estado con el nuevo 'selected'
		setSelected(new_selected);

		// Resetear el formulario o los valores del establecimiento si es necesario
		setEstablishment(no_new_establishment);

		// Cerrar el diálogo o la ventana de edición
		onCloseEditEstablishment();

		// Mostrar el mensaje de información
		message.info("Para guardar los cambios selecciona \"Modificar\"");
	};

	// Usage:
	//const handleChangeName = (value) => updateSelected("name", value);
	const handleChangeLookerLink = (value) => updateSelected("looker_link", value);
	const handleChangeAddress = (value) => updateSelected("address", value);
	const handleChangeDescription = (value) => updateSelected("description", value);
	const handleChangeCountry = (value) => updateSelected("country", value);
	const handleChangeClient = (value) => updateSelected("is_associated_company", value);
	const handleChangePlan = (value) => updateSelected("plan", value);

	const handleChangeEmitionSpecifications = (value, variable) => {
		let invoice_emition_specifications = selected.invoice_emition_specifications || {};

		invoice_emition_specifications[variable] = value;

		setSelected({
			...selected,
			invoice_emition_specifications
		});
	};

	const handleChangeEmailEmitionSpecifications = (value, variable) => {
		let email_emition_specifications = selected.email_emition_specifications || {};

		email_emition_specifications[variable] = value;

		setSelected({
			...selected,
			email_emition_specifications
		});
	};
	const handleChangeTaxAuthoritySpecifications = (key, value) => {
		let new_tas = selected.tax_authority_specifications;
		new_tas[key] = value;
		updateSelected("tax_authority_specifications", new_tas);
	};

	const handleChangeEstablishmentName = (value) => {
		setEstablishment({
			...establishment,
			name: value
		});
	};
	
	const handleChangeEstablishmentId = (value) => {
		setEstablishment({
			...establishment,
			id: value
		});
	};

	/* SUBMIT COMPANY */

	const update_table = (companies) => {
		const index = companies.findIndex(company => company.id === selected.id);
		if (index !== -1) {
			companies[index] = {
				...selected,
				invoice_emition_specifications: {
					instructions: selected.invoice_emition_specifications.instructions,
					api_key:"",
					certifier: selected.invoice_emition_specifications.certifier,
					visuals: selected.invoice_emition_specifications.visuals,
				}
			};
		}
		return companies;
	};

	const handleSubmit = async () => {
		if(!selected?.type_tid || selected?.type_tid?.trim() === ""){
			message.warning("Porfavor selecciona un tipo de nit.");
			return;
		}
		
		setLoadingSubmit(true);
		setLoading(true);

		const data = {
			id: selected.id,
			address: selected.address,
			name: selected.name,
			country: selected.country,
			plan: selected.plan,
			description: selected.description,
			is_associated_company: selected.is_associated_company,
			tax_authority_specifications: {
				establishments: selected.tax_authority_specifications?.establishments || [],
				agente_retenedor_iva: selected.tax_authority_specifications?.agente_retenedor_iva || false,
				tax_free: selected.tax_authority_specifications?.tax_free || false,
				iva_regimen: selected.tax_authority_specifications?.iva_regimen || "",
				isr_regimen: selected.tax_authority_specifications?.isr_regimen || "",
			},
			accounting_resources: selected.accounting_resources ? selected.accounting_resources : {
				accounting_plan: [],
				diaries: [],
				expense_accounts: [],
				sale_accounts: [],
				others:{
					analytic_accounts:[]
				}
			},
			invoice_emition_specifications: {
				instructions: selected?.invoice_emition_specifications?.instructions || "",
				api_key: selected?.invoice_emition_specifications?.api_key || "",
				certifier: selected.invoice_emition_specifications?.certifier || "grupocds", // set defult value
			},
			email_emition_specifications: {
				email: selected?.email_emition_specifications?.email || "",
				password: selected?.email_emition_specifications?.password || "",
				host: selected?.email_emition_specifications?.host || "",
			},
			type_tid: selected?.type_tid || "",
			contacts: selected?.contacts || [],
		};
		const res = await edit_company(token, data, "complex");
		if (res) {
			message.success(res);
			setCompaniesTable(update_table(companiesTable));			
			updateCompaniesIncludingLocalStorage(update_table(companies));
			onClose();
		}
		
		setLoading(false);
		setLoadingSubmit(false);		
	};

	const changeCorrectlyTypeNit = async (value) => {
		setLoadingSubmit(true);

		const response = await get_company_by_nit_for_entity(token, selected.tid, value);

		if(isObjectEmpty(response)){
			message.error("No existen coincidencias entre el nit y su tipo ingresado");
			setLoadingSubmit(false);
			return;
		}

		const { type_tid } = response;

		if(type_tid === value){
			message.success("Tipo de nit cambiado con exito");
			setSelected({...selected, type_tid: value});
			setLoadingSubmit(false);
			return;
		}

		message.error("El tipo de nit ingresado no coincide con su tipo original");
		setLoadingSubmit(false);
	};

	const searchCompany = async () => {
		if(newCompany?.type_tid.trim() === ""){
			message.error("Porfavor selecciona un tipo de nit");
			return;
		}
		
		if(newCompany?.tid.trim() === ""){
			message.error("Porfavor llena el nit");			
			return;
		}

		setLoadingCreateCompany(true);

		const response = await get_company_by_nit_for_entity(token, newCompany.tid, newCompany.type_tid, true, true);

		const count = Object.values(response).length;

		if(isObjectEmpty(response)){
			message.error("No se encontró una compañia con ese nit");
			setLoadingCreateCompany(false);
			return;
		}
		
		if(count > 6){ // If the count is greater than 6, that means a new company was created.
			message.success("La compañia consultada existe y se registro");
		} else {
			message.info("Esta compañia ya esta en ARO");
		}

		// Show the company information
		const companyInformation = no_selected_company;

		setSelected({...companyInformation, ...response});
		setOpenConsultCompany(true);

		setOpenCreate(false);
		setLoadingCreateCompany(false);
	};
	
	return (
		<>
			<Skeleton avatar loading={loading} active>
				<Row>
					<Col
						span={12}
					>
						<Button type="primary" onClick={showCreateCompanyModal}>
							Crear Compañía Asociada
						</Button>
					</Col>
					<Col
						span={12}
					>
						<Input
							placeholder="Palabra Clave"
							style={{
								width:"90%",
							}}
							onChange={onChangeSearch}
							prefix={
								<SearchOutlined />
							}
						/>

					</Col>
				</Row>
				<List
					pagination={{
						position: "top",
						align: "center",
						disabled: false,
						showSizeChanger: false,
						pageSize: pageSize,
						showTotal:(total, range) => `${range[0]}-${range[1]} de ${total} Compañías`
					}}
					style={{
						textAlign: "start",
					}}
					size="small"
					dataSource={companiesTable}
					header={
						<Row
							style={{
								background: antToken.colorBgLayout,
								borderRadius:"10px"
							}}
						>
							<Col flex="auto">
								<List.Item key={0} >
									<List.Item.Meta 
										title="Nombre"
									/>
									<List.Item.Meta 
										style={{
											textAlign:"right",
										}} 
										title="NIT" 
									/>
								</List.Item>
							</Col>
						</Row>
					}
					renderItem={(item, index) => (
						<List.Item
							key={index}
							onMouseEnter={() => setHoveredItem(index)}
							onMouseLeave={() => setHoveredItem(null)}
							onClick={() => {
								showEdit();
								setSelected(item);
							}}
							style={hover_item(hoveredItem === index, antToken, "invoices", 45)}
						>
							<List.Item.Meta
								description={<p style={{ color:  antToken.colorText }}>{reduceText(item.name, 60)}</p>}
								style={{
									fontWeight: hoveredItem === index ? 600 : 400,
								}}
							/>
							<div>{item.tid}</div>
						</List.Item>
					)}
				/>
			</Skeleton>

			<Drawer
				title="Editar Empresa"
				placement={placement}
				width={1000}
				onClose={onClose}
				open={open}
				extra={
					<Space>
						{
							user.role === UserRols.ARO_ADMIN &&
							<>
								ID: {selected.id}
							</>
						}
						<Button
							onClick={() => {
								onClose();
								setSelected(no_selected_company);
							}}
						>
							Cancelar
						</Button>
						<Button
							type="primary"
							loading={loadingSubmit}
							onClick={handleSubmit}
						>
							Modificar
						</Button>
					</Space>
				}
			>
				<Row gutter={[48, 8]}>
					<Divider>Configuraciones Generales</Divider>
					<Col span={12} > 
						<h3>Nombre: </h3>
						<p>{selected.name}</p>
					</Col>
					<Col span={3} >
						<h3>Nit: </h3>
						<p>{selected.tid}</p>
					</Col>
					<Col span={6} >
						<h3>Tipo: </h3>
						<Select
							style={
								{
									width:"100%"
								}
							}
							showSearch
							value={selected?.type_tid}							
							onChange={changeCorrectlyTypeNit}
							disabled={loadingSubmit || selected?.type_tid}
							placeholder="Selecciona un tipo de nit"
							options={[
								{
									value: "company",
									label: "NIT",
								},
								{
									value: "person",
									label: "CUI",
								},
								{
									value: "foreign",
									label: "Extranjero",
								}
							]}
						/>
					</Col>
					<Col span={2} >
						<h3>Cliente: </h3>
						<Checkbox
							checked={selected.is_associated_company}
							onChange={(e) => handleChangeClient(e.target.checked)}
						/>
					</Col>
					<Col span={12} >
						<h3>Dirección: </h3>
						<TextArea
							rows={4}
							showCount
							maxLength={150}
							value={selected.address}
							onChange={(e) => handleChangeAddress(e.target.value)}
						/>
					</Col>
					<Col span={12} >
						<h3>Descripción: </h3>
						<TextArea
							rows={5}
							showCount
							maxLength={300}
							value={selected.description}
							onChange={(e) => handleChangeDescription(e.target.value)}
						/>
					</Col>
					<Col span={12} >
						<h3>País: </h3>
						<Input
							showCount
							maxLength={5}
							value={selected.country}
							onChange={(e) => handleChangeCountry(e.target.value)}
						/>
					</Col>
					<Col span={12} >
						<h3>Plan: </h3>
						<Select
							style={
								{
									width:"100%"
								}
							}
							showSearch
							placeholder="Selecciona un plan"
							value={selected?.plan}
							onChange={handleChangePlan}
							options={[
								{
									value: "advanced",
									label: "Avanzado",
								},
								{
									value: "simple",
									label: "Simple",
								},
								{
									value: "none",
									label: "Ninguno",
								},
							]}
						/>
					</Col>
					<Divider>Especificaciones de Emisión de Facturas</Divider>
					<Col span={9}>
						<h3>Instrucciones en Factura: </h3>
						<TextArea 
							value={selected.invoice_emition_specifications?.instructions || ""} 
							onChange={(e) => handleChangeEmitionSpecifications(e.target.value, "instructions")}
						/>	
					</Col>
					<Col span={9}>
						<h3>Llave de Certificación: </h3>
						<TextArea 
							value={selected.invoice_emition_specifications?.api_key || ""} 
							onChange={(e) => handleChangeEmitionSpecifications(e.target.value, "api_key")}
						/>
					</Col>
					<Col span={6}>
						<h3>Certificador</h3>
						<Select 							
							value={selected.invoice_emition_specifications?.certifier || "grupocds"}
							onChange={(value) => handleChangeEmitionSpecifications(value, "certifier")}
							style={{width: "100%"}}
						>
							<Select.Option value="grupocds">Grupo CDS</Select.Option>
							<Select.Option value="infile">INFILE</Select.Option>
						</Select>
					</Col>
					<Divider>Especificaciones de Emisión de Correos Electrónicos</Divider>
					<Col span={8}>
						<h3>Correo Electrónico: </h3>
						<Input 
							value={selected.email_emition_specifications?.email || ""} 
							onChange={(e) => handleChangeEmailEmitionSpecifications(e.target.value, "email")}
						/>	
					</Col>
					<Col span={8}>
						<h3>Contraseña: </h3>
						<Input.Password 
							iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} 
							value={selected.email_emition_specifications?.password || ""} 
							onChange={(e) => handleChangeEmailEmitionSpecifications(e.target.value, "password")}
						/>
					</Col>
					<Col span={8}>
						<h3>Host: </h3>			
						<Select
							style={
								{
									width:"100%"
								}
							}
							placeholder="Selecciona un host"
							value={selected?.email_emition_specifications?.host || ""}
							onChange={(value) => handleChangeEmailEmitionSpecifications(value, "host")}
							options={[
								{
									value: "smtp.gmail.com",
									label: "Gmail",
								},
								{
									value: "smtp.office365.com",
									label: "Outlook/Hotmail",
								},
								{
									value: "smtp.mail.yahoo.com",
									label: "Yahoo Mail",
								},
							]}
						/>
					</Col>
					<Col span={24}>
						<h3>Contáctos: </h3>			
						<Contacts
							contacts={selected.contacts ? selected.contacts : []}
							onChangeContacts={value => setSelected({...selected, contacts: value})}
						/>
					</Col>
					<Divider>Especificaciones de la Autoridad Tributaria</Divider>
					<Col span={8} >
						<h3>Régimen IVA: </h3>
						<Select
							style={
								{
									width:"100%"
								}
							}
							showSearch
							placeholder="Selecciona un Régimen IVA"
							value={selected?.tax_authority_specifications?.iva_regimen? selected?.tax_authority_specifications?.iva_regimen: ""}
							onChange={(e) => handleChangeTaxAuthoritySpecifications( "iva_regimen" , e)}
							options={[
								{
									value: "GEN",
									label: "General",
								},
								{
									value: "EXE",
									label: "Exento",
								},
								{
									value: "PEQ",
									label: "Pequeño Contribuyente",
								},
								{
									value: "PEE",
									label: "Pequeño Contribuyente Electrónico",
								},
								{
									value: "AGR",
									label: "Agropecuario",
								},
								{
									value: "AGE",
									label: "Agropecuario Electrónico",
								},
							]}
						/>
					</Col>
					<Col span={8} >
						<h3>Régimen ISR: </h3>
						<Select
							style={
								{
									width:"100%"
								}
							}
							showSearch
							placeholder="Selecciona un Régimen ISR"
							value={selected.tax_authority_specifications.isr_regimen? selected.tax_authority_specifications.isr_regimen: ""}
							onChange={(e) => handleChangeTaxAuthoritySpecifications( "isr_regimen" , e)}
							options={[
								{
									value: "NAPL",
									label: "No aplica",
								},
								{
									value: "RSUAL",
									label: "Trimestral (Sobre Utilidades)",
								},
								{
									value: "ROSIAL",
									label: "Mensual (Opcional Simplificado)",
								}
							]}
						/>
					</Col>
					<Col span={8} >
						<h3>Agente Retenedor de IVA:</h3>
						<Checkbox
							checked={
								selected.tax_authority_specifications.agente_retenedor_iva? selected.tax_authority_specifications.agente_retenedor_iva: false
							}
							onChange={(e) => handleChangeTaxAuthoritySpecifications( "agente_retenedor_iva" , e.target.checked)}
						/>
					</Col>
					<Col span={24} >
						<h3>Establecimientos:</h3>
						<Table
							columns={stablishment_columns}
							dataSource={selected.tax_authority_specifications.establishments}
							showSorterTooltip={{
								target: "sorter-icon",
							}}
							footer={() =>
								<Button
									onClick={showCreateEstablishment}
								>Agregar</Button>
							}
						/>
					</Col>
					<Divider>Especificaciones de la Base de Datos Final</Divider>
					{(selected.database === null) && 
						<Col span={24} >
							<h3>No hay una base de datos en esta compañia</h3>
						</Col>
					}
					{selected.is_associated_company && (
						(selected.database !== null) &&
					<>
						<Col span={8}>
							<h3>Sistema: </h3>
							<p>{selected.database.system}</p>
						</Col>
						<Col span={8}>
							<h3>Base de Datos: </h3>
							<p>{selected.database.name}</p>
						</Col>
						<Col span={8}>
							<h3>Versión: </h3>
							<p>{selected.database.version}</p>
						</Col>
					</>
					)}
				</Row>
				<Divider>Configuraciones de Funcionamiento</Divider>
				{selected.is_associated_company && selected.database !== null && (
					<div>
						<h3>Nomenclatura de Compras: </h3>
						<div
							style={{
								width: "100%",
								display: "flex",
								justifyContent: "center",
								alignContent: "center",
							}}
						>
							<Tooltip title="Recargar">
								<Button
									loading={nomenclatureLoading}
									type="primary"
									shape="circle"
									icon={<ReloadOutlined />}
									onClick={() => {
										handleReloadNomenclature();
									}}
								/>
							</Tooltip>
						</div>
						<Transfer
							dataSource={
								selected.accounting_resources?.accounting_plan
									? selected.accounting_resources?.accounting_plan.map(
										(element) => ({
											...element,
											key: element.id,
										})
									)
									: []
							}
							showSearch
							filterOption={(inputValue, item) => {
								const searchValue = inputValue.toLowerCase();
								return (
									item.name.toLowerCase().includes(searchValue) ||
									item.description?.toLowerCase().includes(searchValue) ||  // Busca en la descripción si existe
									item.category?.toLowerCase().includes(searchValue) ||    // Busca en la categoría si existe
									item.code?.toLowerCase().includes(searchValue)           // Busca en el código si existe
								);
							}}
							
							oneWay
							listStyle={{
								width: 450,
								height: 450,
							}}
							titles={["Cuentas Disponibles", "Cuentas de Compra Asignadas"]}
							targetKeys={
								selected.accounting_resources?.expense_accounts
									? selected.accounting_resources?.expense_accounts
									: []
							}
							selectedKeys={selectedKeysExpenses}
							onChange={handleChangeNomenclatureExpenses}
							onSelectChange={handleSelectChangeNomenclatureExpenses}
							render={(item) => item.display_name}
							style={{
								marginBottom: 16,
								marginTop: "10px",
							}}
						/>
					</div>
				)}
				{selected.is_associated_company && selected.database !== null && (
					<div>
						<h3>Nomenclatura de Ventas: </h3>
						<div
							style={{
								width: "100%",
								display: "flex",
								justifyContent: "center",
								alignContent: "center",
							}}
						>
							<Tooltip title="Recargar">
								<Button
									loading={nomenclatureLoading}
									type="primary"
									shape="circle"
									icon={<ReloadOutlined />}
									onClick={() => {
										handleReloadNomenclature();
									}}
								/>
							</Tooltip>
						</div>
						<Transfer
							dataSource={
								selected.accounting_resources?.accounting_plan
									? selected.accounting_resources?.accounting_plan.map(
										(element) => ({
											...element,
											key: element.id,
										})
									)
									: []
							}
							showSearch
							filterOption={(inputValue, item) => {
								const searchValue = inputValue.toLowerCase();
								return (
									item.name.toLowerCase().includes(searchValue) ||
									item.description?.toLowerCase().includes(searchValue) ||  // Busca en la descripción si existe
									item.category?.toLowerCase().includes(searchValue) ||    // Busca en la categoría si existe
									item.code?.toLowerCase().includes(searchValue)           // Busca en el código si existe
								);
							}}
							oneWay
							listStyle={{
								width: 450,
								height: 450,
							}}
							titles={["Cuentas Disponibles", "Cuentas de Venta Asignadas"]}
							targetKeys={
								selected.accounting_resources?.sale_accounts
									? selected.accounting_resources?.sale_accounts
									: []
							}
							selectedKeys={selectedKeysSales}
							onChange={handleChangeNomenclatureSales}
							onSelectChange={handleSelectChangeNomenclatureSales}
							render={(item) => item.display_name}
							style={{
								marginBottom: 16,
								marginTop: "10px",
							}}
						/>
					</div>
				)}
				{selected.client && (
					<div>
						<h3>Link Reporte Looker Studio: </h3>
						<Input
							value={selected.looker_link}
							onChange={(e) => handleChangeLookerLink(e.target.value)}
						/>
					</div>
				)}
				
			</Drawer>
			<Modal 
				title="Crear Compañía Asociada" 
				open={openCreate} 
				onCancel={cancelCreateCompany}
				footer={
					<>
						<Button
							loading={loadingCreateCompany}
							onClick={cancelCreateCompany}
						>
							Cancelar
						</Button>
						<Button
							loading={loadingCreateCompany}
							type="primary"
							onClick={searchCompany}
						>
							Consultar y Crear
						</Button>
					</>
				}
			>
				{
					!loadingCreateCompany &&
					<>
						<Space.Compact style={{width: "100%"}}>
							<Select
								placeholder="Ingresa el tipo de nit"
								style={{
									width: "25%",
									marginTop: "10px",
									marginBottom: "10px",
								}}
								options={optionsTidTypes}
								value={newCompany.type_tid}
								onChange={(value) => setNewCompany({...newCompany, type_tid: value})}
							/>

							<Input
								placeholder="Ingresa Nit"
								style={{
									marginTop: "10px",
									marginBottom: "10px",
								}}
								value={newCompany.tid}
								onChange={(e) => setNewCompany({...newCompany, tid: e.target.value})}
								loading={loading}
							/>
						</Space.Compact>
					</>
				}
				{
					loadingCreateCompany &&
					<LoadingOutlined />
				}
			</Modal>
			<Modal
				title="Información Compañia"
				open={openConsultCompany}
				onCancel={() => setOpenConsultCompany(false)}
				footer={
					<Button
						type="primary"
						onClick={() => setOpenConsultCompany(false)}
					>
						Cerrar
					</Button>
				}
			>
				<InformationComponent title={"Nombre"} attribute={selected?.name}/>
				<InformationComponent title={"Nit"} attribute={selected?.tid}/>
				<InformationComponent title={"Pais"} attribute={selected?.country}/>
				<InformationComponent title={"Direccion"} attribute={selected?.address}/>
				<InformationComponent title={"Tipo de TID"} attribute={TypeTidCategory[selected?.type_tid]}/>
			</Modal>
			<Modal
				title="Crear Establecimiento"
				open={openCreateEsablishment}
				onCancel={onCloseCreateEstablishment}
				footer={
					<Button
						type="primary"
						onClick={handleCreateEstablishment}
					>
						Crear
					</Button>
				}
			>
				<h3>Nombre</h3>
				<Input 
					value={establishment.name} 
					onChange={(e) => handleChangeEstablishmentName(e.target.value)}/>
				<h3>Código</h3>
				<InputNumber 
					min={1} 
					max={1000} 
					value={establishment.id} 
					onChange={handleChangeEstablishmentId} 
					controls={false}
				/>
			</Modal>
			<Modal
				title="Editar Establecimiento"
				open={openEditEsablishment}
				onCancel={onCloseEditEstablishment}
				footer={
					<Button
						type="primary"
						onClick={handleEditEstablishment}
					>
						Editar
					</Button>
				}
			>
				<h3>Nombre</h3>
				<Input 
					value={establishment.name} 
					onChange={(e) => handleChangeEstablishmentName(e.target.value)}/>
			</Modal>
		</>
	);
};

Companies.propTypes = {
	token: PropTypes.string.isRequired,
	user: PropTypes.shape({
		role: PropTypes.string.isRequired,
	}).isRequired,
};
